module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-input', _vm._b({
    ref: "input",
    attrs: {
      "value": _vm.value,
      "type": _vm.type,
      "placeholder": _vm.placeholder,
      "readonly": _vm.readonly,
      "disabled": _vm.disabled,
      "autosize": _vm.autosize
    },
    on: {
      "input": _vm.inputHandler,
      "focus": _vm.focus,
      "blur": _vm.blurHandler,
      "change": _vm.changeHandler
    }
  }, 'el-input', _vm.$attrs, false), [_vm._t("default"), _vm._v(" "), _vm._t("prefix", null, {
    "slot": "prefix"
  }), _vm._v(" "), (!_vm.disabled) ? _c('rt-icon', {
    attrs: {
      "slot": "suffix",
      "name": "rt-base-edit"
    },
    on: {
      "click": _vm.inputFocus
    },
    slot: "suffix"
  }) : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0fc1bac2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-xpc/src/components/form/rtInput.vue
// module id = 1457
// module chunks = 91